import getCurrentUrl from './utils/getCurrentUrl';
import buildAuthorizationUrl from './utils/buildAuthorizationUrl';
const getLoginUrl = (authServerConfig, clientConfig, redirectUri) => {
    return buildAuthorizationUrl(Object.assign({ responseType: 'none', redirectUri: redirectUri || getCurrentUrl(window.location.href) }, clientConfig), authServerConfig);
};
export { getLoginUrl };
//# sourceMappingURL=getLoginUrl.js.map